import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.unicamp.br/fe-dac/v1'
});

export async function getCountries() {
  const response = await api.get('/countries');

  return response.data
    .map(item => item.nome?.abreviado)
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, 'pt'));
}
